import * as React from 'react';
import { IRestBoardCommonActivity } from '../../../../../../../../types/rest/activity/IRestBoardCommonActivity';
import { IRestBoardActivityBase } from '../../../../../../../../types/rest/activity/IRestBoardActivityBase';
import { IActivityProps } from '../../types';
import { TActivity } from '../../../../../../../../store/activities/types';
import { ActivityItemBody } from '../ActivityItemBody/ActivityItemBody';
import { ActivityHeader } from '../ActivityHeader/ActivityHeader';
import { ActivityItemName } from '../ActivityItemName/ActivityItemName';
import { Icon } from 'kui';
import { blockMarkdown } from '../../../../../../../../helper/markdownHelper';
import { msFileThumbnailStorage } from '../../../../../../../../helper/authorisation/microsoft/storage/msThumbnail';
import { AnalyzeRender } from '../../../../../../helpers/memoizeHelper';
// @ts-ignore
const analyzeRender = window.Settings.development ? new AnalyzeRender(`BoardActivityName`) : null;

export function BoardActivityName ({
    activity
}: IActivityProps<IRestBoardCommonActivity>) {
    if (analyzeRender) analyzeRender.call(activity.id);
    const oldBoardActivity: IRestBoardActivityBase = {
        ...activity,
        dashboard: {
            ...activity.dashboard,
            name: activity.oldValue
        }
    };
    const { label } = activity as TActivity;
    const [newNameMarkdown, setNewNameMarkdown] = React.useState('');
    const [oldNameMarkdown, setOldNameMarkdown] = React.useState('');

    React.useEffect(() => {
        let newName = activity.newValue;
        let oldName = activity.oldValue;

        setNewNameMarkdown(blockMarkdown(newName));
        setOldNameMarkdown(blockMarkdown(oldName));

        if (msFileThumbnailStorage.is()) {
            if (newName) {
                msFileThumbnailStorage.getSrcThumbnails(newName)
                    .then((text) => {
                        setNewNameMarkdown(blockMarkdown(text));
                    })
                    .catch(() => {});
            }
            if (oldName) {
                msFileThumbnailStorage.getSrcThumbnails(oldName)
                    .then((text) => {
                        setOldNameMarkdown(blockMarkdown(text));
                    })
                    .catch(() => {});
            }
        }
    }, [activity]);
    return (
        <ActivityItemBody
            header={<ActivityHeader label={label} activity={activity} />}
            activity={oldBoardActivity}
        >
            {activity.oldValue && <ActivityItemName name={oldNameMarkdown} isRemove isMarkdown tooltip={activity.oldValue} />}
            {activity.oldValue && <Icon xlink={'forward'} size={24} />}
            <ActivityItemName name={newNameMarkdown} isMarkdown tooltip={activity.newValue} />
        </ActivityItemBody>
    );

}
